export default __webpack_public_path__ + "static/media/Background_00258.5bd85324.png";